<template>
  <div class="blog-wrapper">
    <div class="header font">
      <div class="pad-cover" :style="`background-image: url(${post.image})`">
        <div class="header-content">
          <div class="title container">
            <h1>{{ post.title }}</h1>
          </div>
        </div>
      </div>
      <div class="header-bottom">
        <div class="container">
          <div class="blog-info">
            {{ post.time }}·{{ post.tag }}
          </div>
        </div>
      </div>
    </div>
    <div class="blog-body">
      <div class="container">
        <div class="blog-content font">
          <div class="block-item">
            <img class="img-item" src="../assets/post-6-1.jpg"/>
          </div>
          <div class="block-item">
            <p style="font-size: 20px;">
              <span style="color: #170202;">專為公益夥伴設計的功能，</span>讓每一句感謝，像超人一樣迅速又溫暖地抵達。<span style="color: #170202;">更輕鬆且有溫度地傳遞每一份感謝，回覆品質與效率UP! UP!</span>
            </p>
          </div>
          <div class="block-item">
            <p style="font-size: 24px;color: #030303; font-weight: bold;">
              <span>感謝模版操作流程指南</span>
            </p>
          </div>
          <div class="block-item">
            <p style="text-align: left; font-size: 20px;"><span style="color: #444444;">入口一：待感謝頁面 - 快速整理與管理感謝模版。</span><br><span style="color: #444444;">入口二：互動卡感謝留言階段 -</span>使用感謝模版，<span style="color: #444444;">與捐贈者保持良好互動及溝通。</span></p>
          </div>
          <div class="block-item">
            <div class="separator"></div>
          </div>
          <div class="block-item">
            <p style="font-size: 24px;"><strong>入口一：待感謝頁面(管理感謝模版:新增/編輯/刪除)</strong></p>
          </div>
          <div class="block-item center">
            <img class="img-item" src="../assets/post-6-2.jpg"/>
          </div>
          <div class="block-item">
            <p style="text-align: left; font-size: 100%;">點擊[我的]-[待感謝]-[感謝模版圖示]，新增/編輯/刪除感謝模版。所有模版將顯示於常用感謝總覽中，方便隨時查閱使用。<br><span style="color: #3b3838;">讓常用的感謝話語，一鍵儲存、隨時套用，節省時間也保留真誠。</span><br></p>
          </div>
          <div class="block-item">
            <div class="separator"></div>
          </div>
          <div class="block-item">
            <p style="font-size: 24px;"><strong>入口二：互動卡留言感謝階段-(運用感謝模版:使用/編輯/新增)</strong></p>
          </div>
          <div class="block-item center">
            <img class="img-item" src="../assets/post-6-3.jpg"/>
          </div>
          <div class="block-item">
            <p>打開待感謝的互動卡。點擊「寫下感謝」 ，點選「常用感謝」按鈕，從列表中選擇合適的模板。按下「確認發送」。留言將會顯示於互動卡中。一鍵讓感謝有溫度，且快速又輕鬆!</p>
          </div>
          <div class="block-item">
            <div class="separator"></div>
          </div>
          <div class="block-item">
            <p style="font-size: 24px;"><strong>標籤功能與分類</strong></p>
          </div>
          <div class="block-item center">
            <img class="img-item" src="../assets/post-6-4.jpg"/>
          </div>
          <div class="block-item">
            <p>不同的感謝有不同的語氣與對象，用標籤設定，替您快速找到最適合的一句話。<br>️預設標籤：GC代贈感謝、需求感謝、索取感謝<br>✍️ 自建標籤：可自定義（最多6字） <br>⚠️ 注意事項：標籤為必填欄位</p>
          </div>
          <div class="block-item center">
            <img class="img-item" src="../assets/post-6-5.jpg"/>
          </div>
          <div class="block-item">
            <p style="text-align: center;">兩種便捷入口設計，更直覺式操作。簡化回覆流程，輕鬆與捐贈者互動。<br><strong>讓每一句感謝，像超人一樣迅速又溫暖地抵達!</strong></p>
          </div>
          <div class="block-item">
            <div class="separator"></div>
          </div>
          <div class="block-item">
            <p style="text-align: center;">📣碰到障礙嗎?直接進入--&gt;<a href="https://drive.google.com/file/d/14W3927In1YDUpdXnVJ02CvS3DpoUzDTM/view?usp=sharing" data-type="undefined" target="_blank"><u>超級詳細感謝模版教學</u></a></p>
          </div>
        </div>
      </div>
    </div>
    <div class="blog-footer">
      <div class="container">
        <div class="footer-nav">
          <div class="btn-previous footer-btn">
            <div>上一篇</div>
            <a v-if="prev" class="title" :href="prev.link">{{ prev.title }}</a>
          </div>
          <div class="btn-next footer-btn">
            <div>下一篇</div>
            <a v-if="next" class="title" :href="next.link">{{ next.title }}</a>
          </div>
        </div>
        <div class="footer-toolbar">
          <a target="_self" href="/" class="back-link">
            <span class="left-open-big"></span>
            &nbsp;返回網站
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    post: {
      type: Object,
      default: () => ({})
    },
    prev: {
      type: Object,
      default: null
    },
    next: {
      type: Object,
      default: null
    }
  }
}
</script>
<style lang="less">
.font {
  font-family: montserrat,'PingFang TC','Microsoft JhengHei','微軟正黑體',STXihei,sans-serif;
}

.center {
  text-align: center;
}

.blog-wrapper {
  .container {
    position: relative;
    max-width: 816px;
    margin: 0 auto;
    padding: 0;
    padding: 0 15px;

    @media screen and (min-width: 728px) and (max-width: 879px) {
      max-width: 640px;
    }
    @media screen and (min-width: 590px) and (max-width: 727px) {
      max-width: 556px;
    }
    @media screen and (min-width: 490px) and (max-width: 589px) {
      max-width: 456px;
    }
    @media screen and (min-width: 370px) and (max-width: 429px) {
      max-width: 336px;
    }
    @media screen and (max-width: 349px) {
      max-width: 296px;
    }
  }

  .header {
    .pad-cover {
      background-repeat: no-repeat;
      background-size: cover;
      background-color: transparent;
      background-position: 50% 50%;
      color: #fff;
      height: 340px;
      display: table;
      width: 100%;

      // @media screen and (max-width: 727px) {
      //   height: 220px;
      // }

      .header-content {
        padding: 40px 0 60px;
        display: table-cell;
        vertical-align: bottom;
      }

      .title {
        font-family: "istok web", helvetica, 'Lisong Pro', 'PMingLiU', 'PingFang TC','Microsoft JhengHei',"微軟正黑體",STXihei, sans-serif;
        text-shadow: 0 1px 12px rgb(0 0 0 / 35%);
      }
    }

    .header-bottom {
      .blog-info {
        padding: 12px 0;
        border-bottom: 1px solid #ddd;
        color: #a9aeb2;
        font-size: 14px;
      }
    }
  }
}

.blog-body {
  padding: 30px 0;
  .blog-content {
    color: #444;
    line-height: 1.7;
    word-wrap: break-word;
    font-size: 20px;
    font-weight: 400;
    font-style: normal;

    .video-wrapper {
      width: 100%;
      padding-bottom: 56.25%;
      position: relative;
    }

    p {
      margin: 0;
      padding: 0;
      border: 0;
    }

    .block-item {
      margin-bottom: 30px;
    }

    .img-item {
      max-width: 100%;
    }

    .separator {
      height: 2px;
      background: #ddd;
      width: 240px;
      margin: 0 auto;
      border-radius: 2px;
    }
  }
}
.blog-footer {
  padding-top: 30px;
  padding-bottom: 200px;
  background: #fff;
  color: #999;

  .footer-nav {
    padding: 22px 0;
    font-size: 14px;
    border-top: 1px solid #ddd;
    color: #999;
  }

  .btn-previous {
    padding-right: 10px;
    box-sizing: border-box;
    color: #a9aeb2;
  }
  .footer-btn {
    display: inline-block;
    zoom: 1;
    width: 50%;
    vertical-align: top;
  }

  .btn-next {
    padding-left: 10px;
    box-sizing: border-box;
    color: #a9aeb2;
  }

  .title {
    font-size: 24px;
    font-style: normal;
    font-weight: 300;
    color: #000;
    margin-top: 5px;
    line-height: 1.25;
    font-family: "istok web", helvetica, 'Lisong Pro', 'PMingLiU', 'PingFang TC','Microsoft JhengHei',"微軟正黑體",STXihei, sans-serif;
    cursor: pointer;
    text-decoration: none;
  }

  .footer-toolbar {
    font-size: 14px;
    padding-top: 15px;
    border-top: 1px solid #ddd;

    .back-link {
      display: inline-block;
      margin: 0 30px 10px 0;
      line-height: 20px;
      color: #a9aeb2;
      text-decoration: none;

      .left-open-big {
        &::before {
          content: "<";
          font-family: entypo;
          font-style: normal;
          font-weight: 400;
          display: inline-block;
          text-decoration: inherit;
          width: 1em;
          text-align: center;
          font-variant: normal;
          text-transform: none;
          line-height: 1em;
        }
      }
    }
  }
}
</style>